module.exports = __webpack_public_path__ + "static/dna-a16470b98e0ee79be403ede855ca12f2.gif";